import React, { useMemo } from "react";
import { connect } from "react-redux";
import ponticManager from "../../../../data/manager/ponticManager";
import * as THREE from "three";
import PonticModel from "../../../../Components/CreateModal/PonticModel";
import { getOpacity } from "../../../../common/tooth";
import { TOOTH_GUM_TYPE } from "../../../../data/constant/toothConstant";

function PonticDataPro2(props) {
  const { keyframeNumber, sliderVal, ponticCheckboxValue } = props;

  const stageNumber = keyframeNumber + 1;

  const ponticModelList = useMemo(() => {
    const upperPonticModelList = ponticManager.getPonticModelListByStageNumberAndToothGumType(stageNumber, TOOTH_GUM_TYPE.UPPER);
    const lowerPonticModelList = ponticManager.getPonticModelListByStageNumberAndToothGumType(stageNumber, TOOTH_GUM_TYPE.LOWER);
    return [...upperPonticModelList, ...lowerPonticModelList];

  }, [stageNumber]);

  return (
    <group name={"pontic"} visible={ponticCheckboxValue}>
      {
        ponticModelList.map((ponticModel) => {
          const { model, toothGumType } = ponticModel;
          const targetModel = model || new THREE.BufferGeometry();
          const opacity = getOpacity(toothGumType, sliderVal);
          return (
            <PonticModel model={targetModel} opacity={opacity} />
          );
        })
      }
    </group>
  );
}

const mapStateToProps = (state) => ({
  keyframeNumber: state.webViewer.keyframeNumber,
  sliderVal: state.webViewer.sliderVal,
  ponticCheckboxValue: state.webViewer.ponticCheckboxValue,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PonticDataPro2);
